import * as React from 'react';

import { cn } from '../../lib/cn';

// Marks a block with no endpoint behind it. Deliberately visible: a screenshot must
// never read as real data.
export const MockBadge = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    title="Placeholder data - no API for this yet"
    className={cn(
      'rounded-[20px] border border-dusq-warning/40 px-1.5 py-[1px]',
      'font-dusq text-[9px] font-bold uppercase tracking-wide text-dusq-warning',
      className
    )}
    {...props}
  >
    Mock
  </span>
));
MockBadge.displayName = 'MockBadge';
